"use client";

import Image from "next/image";
import Link from "next/link";
import SocialLinks from "./social-links";
import { MapPin, Phone, Mail } from "lucide-react";
import { useEffect, useState } from "react";

const footerWidget = [
  {
    id: 1,
    title: "Quick Links",
    footer__links: [
      { list: "Privacy Policy", path: "/privacy-policy" },
      { list: "Terms & Condition", path: "/terms-and-conditions" },
      { list: "Returns & Refunds", path: "/returns-and-refunds" },
    ],
  },
  {
    id: 2,
    title: "Customer Services",
    footer__links: [
      { list: "Help & Contact Us", path: "/contact" },
      { list: "Online Store", path: "/shop" },
      { list: "FAQs", path: "/faq" },
    ],
  },
];

export default function Footer() {
  const [flakes, setFlakes] = useState<any[]>([]);

  // Snowfall generation
  useEffect(() => {
    const count = 50;
    const flakeArray = Array.from({ length: count }).map(() => ({
      left: Math.random() * 100,
      size: 3 + Math.random() * 4,
      duration: 4 + Math.random() * 6,
      delay: Math.random() * 3,
      opacity: 0.3 + Math.random(),
    }));

    setFlakes(flakeArray);
  }, []);

  const snowKeyframes = `
    @keyframes snowFooter {
      0% { transform: translateY(-10vh) rotate(0deg); }
      100% { transform: translateY(100vh) rotate(360deg); }
    }
  `;

  return (
    <>
      <style>{snowKeyframes}</style>

      <footer
        style={{
          backgroundColor: "#000",
          color: "#fff",
          paddingTop: "100px",
          marginTop: "80px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Snowfall */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            pointerEvents: "none",
            zIndex: 1,
          }}
        >
          {flakes.map((f, i) => (
            <div
              key={i}
              style={{
                position: "absolute",
                top: "-10vh",
                left: `${f.left}%`,
                width: `${f.size}px`,
                height: `${f.size}px`,
                borderRadius: "50%",
                background: `rgba(255,255,255,${f.opacity})`,
                filter: "blur(1px)",
                animation: `snowFooter ${f.duration}s linear infinite`,
                animationDelay: `${f.delay}s`,
              }}
            />
          ))}
        </div>

        {/* Main Footer Container */}
        <div
          style={{
            maxWidth: "1300px",
            margin: "0 auto",
            padding: "0 24px",
            position: "relative",
            zIndex: 5,
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "40px",
              marginBottom: "80px",
            }}
          >
            {/* Text Logo */}
            <div
              style={{
              color: "#fff",
                borderRadius: "16px",
                padding: "32px",
                border: "1px solid #222",
                transition: "0.3s",
              }}
            >
              <div style={{ marginBottom: "24px" }}>
                <h2
                  style={{
                                  color: "#fff",

                    fontSize: "32px",
                    fontWeight: 900,
                    letterSpacing: "2px",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Urban <span style={{ color: "#ffffffff" }}>Attire</span>
                </h2>
              </div>

              <p
                style={{
                  fontSize: "14px",
                  color: "#ccc",
                  lineHeight: 1.6,
                  marginBottom: "22px",
                }}
              >
                Premium clothing & urban fashion for the next generation. Style begins here.
              </p>

              <SocialLinks />
            </div>

            {/* Contact Info */}
            <div
              style={{
               
                borderRadius: "16px",
                padding: "32px",
                border: "1px solid #222",
                transition: "0.3s",
              }}
            >
              <h4
                style={{
                  color: "#fff",
                  fontSize: "18px",
                  fontWeight: 800,
                  marginBottom: "20px",
                }}
              >
                Contact Us
              </h4>

              <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                <div style={{ display: "flex", gap: "12px" }}>
                  <MapPin style={{ color: "#ff6b6b" }} />
                  <p style={{ margin: 0, color: "#ccc" }}>
                    Dhaka Outlet, Bailey Road, AQP Shopping Mall
                  </p>
                </div>

                <div style={{ display: "flex", gap: "12px" }}>
                  <Phone style={{ color: "#ff6b6b" }} />
                  <a href="tel:+8801622534977" style={{ color: "#ff6b6b", fontWeight: 600 }}>
                    +880 1622-534977
                  </a>
                </div>

                <div style={{ display: "flex", gap: "12px" }}>
                  <Mail style={{ color: "#ff6b6b" }} />
                  <a
                    href="mailto:support@urbanattire.com"
                    style={{ color: "#ff6b6b", fontWeight: 600 }}
                  >
                    support@urbanattire.com
                  </a>
                </div>
              </div>
            </div>

            {/* Footer Widgets */}
            {footerWidget.map((item) => (
              <div
                key={item.id}
                style={{
                 
                  
                  borderRadius: "16px",
                  padding: "32px",
                  border: "1px solid #222",
                }}
              >
                <h4 style={{ fontSize: "18px", fontWeight: 800, marginBottom: "20px" ,color:"#fff"}}> 
                  {item.title}
                </h4>

                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {item.footer__links.map((link, i) => (
                    <li key={i} style={{ marginBottom: "12px" }}>
                      <Link
                        href={link.path}
                        style={{
                          color: "#ccc",
                          textDecoration: "none",
                          fontSize: "14px",
                          transition: "0.3s",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#ff6b6b";
                          e.currentTarget.style.marginLeft = "4px";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#ccc";
                          e.currentTarget.style.marginLeft = "0px";
                        }}
                      >
                        → {link.list}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Footer Bottom */}
          <div
            style={{
              borderTop: "1px solid #222",
              padding: "24px 0",
              textAlign: "center",
              color: "#777",
            }}
          >
            © 2025 Urban Attire — All Rights Reserved
          </div>
        </div>
      </footer>
    </>
  );
}
